<template>
    <div class="banet-datetime-picker">
        <VueBulmaDatepicker :config="config" :placeholder="placeholder" :clearTooltip="getTranslation('lbl_clear')"
                            @datesSelected="datesSelected"></VueBulmaDatepicker>
    </div>
</template>

<script>
    //requires npm package flatpickr@2.4.2 and bootstrap css

    import VueBulmaDatepicker from './plugins/VueBulmaDatepicker/index.vue'
    import DatepickerLanguages from './plugins/flatpickr/languages'
    import {translationMixin} from '../../../../Banet/mixins/translationMixin';

    export default {
        components: {
            'VueBulmaDatepicker': VueBulmaDatepicker
        },
        props: [ 'language', 'placeholder', 'value' ],
        mixins: [ translationMixin ],
        data: function() {
            return {
                config: {
                    wrap: true,
                    enableTime: true,
                    minuteIncrement: 1,
                    mode: 'single',
                    static: true,
                    time_24hr: true,
                    locale: DatepickerLanguages[this.language] || DatepickerLanguages['en'],
                    defaultDate: this.value,
                    defaultHour: (new Date()).getHours(),
                    clickOpens: false,
                    dateFormat: 'd.m.Y H:i'
                }
            }
        },
        methods: {
            datesSelected: function(newValue) {
                this.$emit('input', newValue[0]);

            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// DateTimePicker.vue?daec2c2c